import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import {
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { I18NextModule } from 'angular-i18next';
import { SharedModule } from '../../shared.module';

@Component({
  standalone: true,
  selector: 'app-request-warning-modal',
  templateUrl: './request-warning-modal.component.html',
  styleUrls: ['./request-warning-modal.component.scss'],
  imports: [CommonModule, SharedModule, I18NextModule, MatDialogModule]
})
export class RequestWarningModalComponent {
  @Output() onResponse = new EventEmitter<boolean>();

  constructor(
      public dialogRef: MatDialogRef<RequestWarningModalComponent>,
    ) {}

  onModalResponse(response: boolean) {
    this.dialogRef.close();
    this.onResponse.emit(response);
  }
}
